/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential cookies — Required for basic site functionality, authentication, and security.`)
};

const es_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies esenciales — Necesarias para la funcionalidad básica del sitio, autenticación y seguridad.`)
};

const de_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essenzielle Cookies — Erforderlich für grundlegende Website-Funktionalität, Authentifizierung und Sicherheit.`)
};

const nl_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiële cookies — Vereist voor basisfunctionaliteit van de site, authenticatie en beveiliging.`)
};

const fr_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies essentiels — Nécessaires au fonctionnement de base du site, à l’authentification et à la sécurité.`)
};

const it_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie essenziali — Necessari per le funzionalità di base del sito, autenticazione e sicurezza.`)
};

const pt_br2_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies essenciais — Necessários para funcionalidade básica do site, autenticação e segurança.`)
};

const pt_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies essenciais — Necessários para funcionalidade básica do site, autenticação e segurança.`)
};

const ja_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必須Cookie — 基本的なサイト機能、認証、セキュリティに必要です。`)
};

const zh_privacy_cookie_essential = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必要Cookie — 基本网站功能、认证和安全所需。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_cookie_essential = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_cookie_essential(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_cookie_essential", locale)
	if (locale === "en") return en_privacy_cookie_essential(inputs)
	if (locale === "es") return es_privacy_cookie_essential(inputs)
	if (locale === "de") return de_privacy_cookie_essential(inputs)
	if (locale === "nl") return nl_privacy_cookie_essential(inputs)
	if (locale === "fr") return fr_privacy_cookie_essential(inputs)
	if (locale === "it") return it_privacy_cookie_essential(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_cookie_essential(inputs)
	if (locale === "pt") return pt_privacy_cookie_essential(inputs)
	if (locale === "ja") return ja_privacy_cookie_essential(inputs)
	return zh_privacy_cookie_essential(inputs)
};